import { render, staticRenderFns } from "./createVLPTRound.vue?vue&type=template&id=02740126&scoped=true&"
import script from "./createVLPTRound.vue?vue&type=script&lang=js&"
export * from "./createVLPTRound.vue?vue&type=script&lang=js&"
import style0 from "./createVLPTRound.vue?vue&type=style&index=0&id=02740126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02740126",
  null
  
)

export default component.exports